import React, { useEffect } from "react";

import { getApp } from "../../ts/index.js";

import registerCustomElement from "./registerCustomElement.jsx";

function Recaptcha({ sitekey }: { sitekey: string }) {
  useEffect(() => {
    void (async () => {
      const app = await getApp();

      // @ts-ignore
      grecaptcha.enterprise.render("g-recaptcha", {
        sitekey,
        callback: async (value: string) => {
          app.ports.interopToElm.send({
            name: "setRecaptchaToken",
            value: { recaptchaToken: value },
          });
        },
        // NOTE: no error-callback is implemented as this means that we have to
        // implement retry prompts.
        //
        // See https://developers.google.com/recaptcha/docs/display#render_param
      });
    })();
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div id="g-recaptcha" data-action="VERIFY" />
    </div>
  );
}

registerCustomElement(Recaptcha, "recaptcha-element");
